import { render, staticRenderFns } from "./ItemCertitification.vue?vue&type=template&id=c1307902&"
import script from "./ItemCertitification.vue?vue&type=script&lang=js&"
export * from "./ItemCertitification.vue?vue&type=script&lang=js&"
import style0 from "./ItemCertitification.vue?vue&type=style&index=0&id=c1307902&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports